var _nMINIMUMYear = -271821;
var MIN_NUMERIC_SASDATE_VALUE = -138061; // 01Jan1582
var MAX_NUMERIC_SASDATE_VALUE = 2936547; // 31Dec9999
var MIN_NUMERIC_SASDATETIME_VALUE = -11928470400; // 01Jan1582:00:00:00
var MAX_NUMERIC_SASDATETIME_VALUE = 253717747199; // 31Dec9999:23:59:59
export var JSDATE_FOR_MAX_SASDATE = new Date(9999, 11, 31, 0, 0, 0);
export var JSDATE_FOR_MAX_SASDATETIME = new Date(9999, 11, 31, 23, 59, 59);
export var JSDATE_FOR_MIN_SASDATE = new Date(1582, 0, 1, 0, 0, 0);
export var JSDATE_FOR_MIN_SASDATETIME = new Date(1582, 0, 1, 0, 0, 0);
var _oSasEpocDateUTC = (function () {
    var sasEpocDateUTC = new Date();
    sasEpocDateUTC.setUTCFullYear(1960, 0, 1);
    sasEpocDateUTC.setUTCHours(0, 0, 0, 0);
    return sasEpocDateUTC;
})();
var _oJsEpocDateUTC = (function () {
    var jsEpocDateUTC = new Date();
    jsEpocDateUTC.setUTCFullYear(1970, 0, 1);
    jsEpocDateUTC.setUTCHours(0, 0, 0, 0);
    return jsEpocDateUTC;
})();
var _nSasEpocOffsetUTC = _oSasEpocDateUTC.valueOf() - _oJsEpocDateUTC.valueOf();
function sasDatetimeToSasDate(nSasDatetime) {
    return Math.floor(nSasDatetime / (60 * 60 * 24));
}
/**
 * returns 1 if the year is a leap year, else returns 0
 * @param {number} [year] year
 * @returns {number} 1 if the year is a leap year, else returns 0.
 * @name sas.ltjs.sasicu.util.CalendarUtil.isLeapYear
 * @static
 * @public
 * @function
 */
export function isLeapYear(year) {
    if (year % 4000 === 0) {
        return false;
    }
    else if (year % 400 === 0) {
        return true;
    }
    else if (year % 100 === 0) {
        return false;
    }
    else if (year % 4 === 0) {
        return true;
    }
    return false;
}
/**
 * returns # of days in month in year
 * @param {number} [month] month (1 is January)
 * @param {number} [year] year
 * @returns {number} the number of days in the specific month in the year.
 * @name sas.ltjs.sasicu.util.CalendarUtil.calculateDaysInMonth
 * @static
 * @public
 * @function
 */
export function calculateDaysInMonth(month, year) {
    var days = 30;
    // 30 days have september, april, june, and november
    // other months have 31 as below (except February)
    if (month === 1 || month === 3 || month === 5 || month === 7 || month === 8 || month === 10 || month === 12) {
        days = 31;
    }
    else if (month === 2) {
        // treat February differently
        days = 28;
        if (isLeapYear(year)) {
            // add 1 for leap years
            days += 1;
        }
    }
    return days;
}
export function stdTimezoneOffset(date) {
    // The actual date-time doesn't matter.
    if (!date) {
        date = new Date();
    }
    else {
        date = new Date(date.getTime());
    }
    // S1437422: In javascript the minimum and maximum dates are:
    //   Min: Tue Apr 20 -271821 05:00:00 GMT-0400 (Eastern Daylight Time)
    //   Max: Fri Sep 12 275760 20:00:00 GMT-0400 (Eastern Daylight Time).
    // When the minimum date is specified, date.setMonth(0) makes it invalid date value
    // and this function returns NaN. The following if-condition block is a workaround.
    // The year of the minimum date value is -271821 where human being didn't exist so
    // that timezone offset is meaningless. In order to get a timezone offset, the
    // year -271820 can be used instead of -271821.
    if (date.getFullYear() === _nMINIMUMYear) {
        date.setFullYear(_nMINIMUMYear + 1);
    }
    // Set to January so that we get either Standard or Daylight time.
    date.setMonth(0);
    var offset1 = date.getTimezoneOffset();
    // Set to June so that we get the other of Standard or Daylight time.
    date.setMonth(5);
    var offset2 = date.getTimezoneOffset();
    // The offset for Daylight time will always be less that the offset for Standard time.
    // Return the Standard time offset (which is the 'raw offset').
    return offset1 > offset2 ? offset1 : offset2;
}
export function dstTimezoneOffset(date) {
    // The actual date-time doesn't matter.
    if (!date) {
        date = new Date();
    }
    else {
        date = new Date(date.getTime());
    }
    // S1437422: In javascript the minimum and maximum dates are:
    //   Min: Tue Apr 20 -271821 05:00:00 GMT-0400 (Eastern Daylight Time)
    //   Max: Fri Sep 12 275760 20:00:00 GMT-0400 (Eastern Daylight Time).
    // When the minimum date is specified, date.setMonth(0) makes it invalid date value
    // and this function returns NaN. The following if-condition block is a workaround.
    // The year of the minimum date value is -271821 where human being didn't exist so
    // that timezone offset is meaningless. In order to get a timezone offset, the
    // year -271820 can be used instead of -271821.
    if (date.getFullYear() === _nMINIMUMYear) {
        date.setFullYear(_nMINIMUMYear + 1);
    }
    // Set to January so that we get either Standard or Daylight time.
    date.setMonth(0);
    var offset1 = date.getTimezoneOffset();
    // Set to June so that we get the other of Standard or Daylight time.
    date.setMonth(5);
    var offset2 = date.getTimezoneOffset();
    // The offset for Daylight time will always be less that the offset for Standard time.
    // Return the Standard time offset (which is the 'raw offset').
    return offset1 < offset2 ? offset1 : offset2;
}
export function inDaylightTime(date) {
    if (!date) {
        date = new Date();
    }
    return date.getTimezoneOffset() < stdTimezoneOffset(date);
}
/**
 * Converts a Date instance or a number corresponding to a JS Date into a SAS DateTime number with
 * an ajustment of day light saving time(DST) because SAS DateTime doesn't consider DST.
 *
 * SAS datetime value is a value representing the number of seconds between January 1, 1960 [epoch]
 * and an hour/minute/second within a specified date.
 * For JS the same number represents the number of milliseconds between January 1, 1970 [epoch] and a
 * specified datetime.
 * @param {object} [oJsDate] A Date instance
 * @returns {number} a number in seconds corresponding to the same DateTime, adjusted to the difference between the 2 epoch.
 * @name sas.ltjs.sasicu.util.CalendarUtil.jsDateToSASDateTime
 * @static
 * @public
 * @function
 */
export function jsDateToSASDateTime(oJsDate) {
    if (!(oJsDate instanceof Date))
        return 0;
    var dt = new Date(oJsDate.getTime());
    var dtUTC = new Date();
    dtUTC.setUTCFullYear(dt.getFullYear(), dt.getMonth(), dt.getDate());
    dtUTC.setUTCHours(dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());
    var nSasDateTime = (dtUTC.getTime() - _nSasEpocOffsetUTC) / 1000;
    // adjust leap years for 4k, 8k, 12k, ...
    var fullYear = oJsDate.getFullYear();
    var year4000s = Math.floor(fullYear / 4000);
    if (year4000s !== 0) {
        var modYear4000s = fullYear % 4000;
        nSasDateTime -= (year4000s - ((modYear4000s === 0 && oJsDate.getMonth() < 2) ? 1 : 0)) * (60 * 60 * 24);
    }
    if (nSasDateTime > MAX_NUMERIC_SASDATETIME_VALUE) {
        nSasDateTime = NaN;
    }
    else if (nSasDateTime < MIN_NUMERIC_SASDATETIME_VALUE) {
        nSasDateTime = NaN;
    }
    return nSasDateTime;
}
/**
 * Converts a number corresponding to a SAS DateTime into a JS Date number with an
 * ajustment of day light saving time(DST) because SAS DateTime doesn't consider DST.
 *
 * @param {number} [nSasDateTime] a Number in seconds corresponding to a SAS DateTime.
 * @returns {Date} a Date instance corresponding to the same Time of January 1, 1970.
 * @name sas.ltjs.sasicu.util.CalendarUtil.sasDateTimeToJsDate
 * @static
 * @public
 * @function
 */
export function sasDateTimeToJsDate(nSasDateTime) {
    // tslint:disable-next-line:strict-type-predicates
    if (typeof nSasDateTime !== 'number') {
        // legacy type check for javascript usage
        return null;
    }
    var DAYS_SINCE_ZERO_AD = 715509;
    var prior = sasDatetimeToSasDate(nSasDateTime) + DAYS_SINCE_ZERO_AD;
    // # of 4000 year cycles (4000 yrs : 146097 * 10 - 1(as 4000 is not a leap yr) = 1460969 )
    var years4000 = Math.floor(prior / 1460969);
    var days4000 = prior % 1460969;
    // # of 400 year cycles (400 yrs : 36524 * 4 + 1(as 400 is a leap yr) = 146097 )
    var years400 = Math.floor(days4000 / 146097);
    var days400 = days4000 % 146097;
    // # 100 yr. cycles not checked ( 100 yrs : 1461 * 25 - 1(as 100 is not a leap yr) = 36524 )
    var years100 = Math.floor(days400 / 36524);
    var days100 = days400 % 36524;
    // # 4 yr cycles not checked ( 4 yrs : 365 * 4 + 1(as 4 is a leap yr) = 1461 )
    var years4 = Math.floor(days100 / 1461);
    var days4 = days100 % 1461;
    var year1 = Math.floor(days4 / 365);
    var day1 = days4 % 365;
    var finalYear = 4000 * years4000 + 400 * years400 + 100 * years100 + 4 * years4 + year1;
    var finalDay = 366; // December 31 of leap year
    if (years100 !== 4 && year1 !== 4) {
        finalDay = day1 + 1;
        finalYear += 1;
    }
    // now have year and day #, find month and day in month
    var month = 1;
    while (month <= 12 && 0 < finalDay) {
        finalDay -= calculateDaysInMonth(month, finalYear);
        month += 1;
    }
    month -= 1; // went one to far
    finalDay += calculateDaysInMonth(month, finalYear);
    month -= 1; // January is now 0 instead of 1.
    var jsDate = new Date();
    var milliTime = Math.floor(nSasDateTime * 1000) % (60 * 60 * 24 * 1000);
    if (milliTime < 0) {
        milliTime = (60 * 60 * 24 * 1000) + Math.floor(milliTime);
    }
    jsDate.setFullYear(finalYear, month, finalDay);
    jsDate.setDate(jsDate.getDate());
    var hours = Math.floor(milliTime / (60 * 60 * 1000));
    var minutes = Math.floor((milliTime % (60 * 60 * 1000)) / (60 * 1000));
    var seconds = Math.floor(((milliTime % (60 * 1000)) / 1000));
    var millisec = milliTime % 1000;
    jsDate.setHours(hours, minutes, seconds, millisec);
    return jsDate;
}
/**
 * Converts a Date instance or a number corresponding to a JS Date into a number corresponding to the SAS Date.
 *    SAS Date value is a value that represents the number of days between January 1, 1960 [epoch] and a
 * specified date.
 * For JS Date, the same number represents the number of milliseconds between January 1, 1970 [epoch] and a
 * specified date.
 * @param {object} [oJsDate] A Date instance
 * @returns {number} a number in days corresponding to the same Date, adjusted to the difference between the 2 epoch.
 * @name sas.ltjs.sasicu.util.CalendarUtil.jsDateToSASDate
 * @static
 * @public
 * @function
 * */
export function jsDateToSASDate(oJsDate) {
    if (!(oJsDate instanceof Date)) {
        return 0;
    }
    var nSasDateTime = jsDateToSASDateTime(oJsDate);
    var nSasDate = sasDatetimeToSasDate(nSasDateTime);
    if (nSasDate > MAX_NUMERIC_SASDATE_VALUE) {
        nSasDate = NaN;
    }
    else if (nSasDate < MIN_NUMERIC_SASDATE_VALUE) {
        nSasDate = NaN;
    }
    return nSasDate;
}
/**
 * Converts a number corresponding to a SAS Date type into a JS Date number.
 *    SAS Date value is a value that represents the number of days between January 1, 1960 [epoch] and a
 * specified date.
 * For JS the same number represents the number of milliseconds between January 1, 1970 [epoch] and a
 * specified date.
 * @param {number} [nSasDate] a Number in days corresponding to a SAS Date.
 * @returns {Date} a Date instance corresponding to the same Time of January 1, 1970.
 * @name sas.ltjs.sasicu.util.CalendarUtil.sasDateToJsDate
 * @static
 * @public
 * @function
 * */
export function sasDateToJsDate(nSasDate) {
    // tslint:disable-next-line:strict-type-predicates
    if (typeof nSasDate !== 'number') {
        // legacy type check for javascript usage
        return null;
    }
    return sasDateTimeToJsDate(nSasDate * 60 * 60 * 24);
}
/**
 *  Converts a number corresponding to a SAS Time into a JS Date instance.
 *    SAS Time value is a value that represents the number of seconds from 00:00:00.
 * For JS the same number represents the number of milliseconds from January 1, 1970 00:00:00:00.
 * @param {object} [oJsDate] A Date instance
 * @returns {number} a number in seconds corresponding to the time portion in the oJsDate.
 * @name sas.ltjs.sasicu.util.CalendarUtil.jsDateToSASTime
 * @static
 * @public
 * @function
 * */
export function jsDateToSASTime(oJsDate) {
    if (!(oJsDate instanceof Date)) {
        return 0;
    }
    return (oJsDate.getHours() * 60 * 60 + oJsDate.getMinutes() * 60 + oJsDate.getSeconds() + oJsDate.getMilliseconds() / 1000);
}
/**
 * Converts a number corresponding to a SAS Time into a JS Date number.
 * @static
 * @public
 * @name sas.ltjs.sasicu.util.CalendarUtil.sasTimeToJsDate
 * @param {number} [nSasTime] a Number in seconds corresponding to a SAS Time.
 * @returns {Date} a Date instance corresponding to the same Time of January 1, 1970.
 * @function
 * */
export function sasTimeToJsDate(nSasTime) {
    // tslint:disable-next-line:strict-type-predicates
    if (typeof nSasTime !== 'number') {
        // legacy type check for javascript usage
        return null;
    }
    var nTime = new Date(1970, 0, 1, 0, 0, 0, 0).getTime() + nSasTime * 1000;
    return new Date(nTime);
}
